import Comments from "./Comments";
import { useContext } from "react";
import GuestbookContext from "../context/GuestbookContext";
import CommentsLoader from "./CommentsLoader";
import { useComments } from "../hooks/useComments";

const CommentsWrapper = () => {
  const { isLoading } = useComments();
  const { totalComments } = useContext(GuestbookContext);

  if (isLoading) return <CommentsLoader />;

  if (totalComments > 0) return <Comments />;

  return null;
};

export default CommentsWrapper;
